'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Styled Wrapper Component. This component is used to wrap the slides.
 * It is private but allows modification by passing a mixin to `<Deck/>`
 * @private
 * @type {StyledComponent}
 * @property {{mixin: ?String, children: Array<Deck.slides,Deck.paging>}} props
 *   A mixin to allow extending Deck's style.
 *
 *   Required Styles are declared as `!important`
 *
 *   **The following properties are locked:**
 *
 *   * `position`
 *   * `top`
 *   * `right`
 *   * `bottom`
 *   * `left`
 *   * `overflow`
 *
 *   In rare cases when these need to be modified an `!important` declaration
 *   is required.
 *   A mixin can be any valid set of CSS rules.
 *
 *   Syntax features are as defined
 *   by styled-components {@link https://www.styled-components.com/docs}
 *
 *   @example
 *   // This private Component shoulld only be used by Decck itself
 *   // It is used as follows
 *   return (
 *     <Wrapper mixin={this.props.mixin}>
 *       {this.paging}
 *       {this.slides}
 *     </Wrapper>
 *   )
 */
var Wrapper = _styledComponents2.default.div.withConfig({
  displayName: 'wrapper__Wrapper'
})(['position:absolute !important;top:0 !important;right:0 !important;bottom:0 !important;left:0 !important;display:flex !important;box-sizing:border-box !important;', ';'], function (_ref) {
  var mixin = _ref.mixin;
  return mixin || '';
});

/**
 * Display name for `<Wrapper/>`
 * @private
 * @type {String}
 */
Wrapper.displayName = 'Wapper';

/**
 * Allowed propTypes for `<Wrapper/>`
 * @private
 * @param {Array<SlidesWrapper,Deck.elements,Dekk.plugins>} children
 * @param {?(String|Array)} mixin
 * @type {Object}
 */
Wrapper.propTypes = {
  children: _propTypes2.default.node,
  mixin: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.string])
};

exports.default = Wrapper;
//# sourceMappingURL=wrapper.js.map